<template>
	<section class="w-full bg-primary py-12 md:py-16">
		<div
			class="mx-auto w-full bg-transparent px-5 py-11 md:px-8 md:py-[60px] lg:px-12"
		>
			<div class="mx-auto w-full 2xl:max-w-[1440px]">
				<header class="flex flex-col items-start gap-6 pb-6 md:pb-9">
					<div class="flex w-full flex-col items-start justify-between">
						<div class="relative">
							<span
								class="font-matter-sq text-2xl leading-normal tracking-tight text-transparent md:text-4xl"
							>
								Descubra imóveis em vídeo
							</span>
							<div
								class="absolute inset-y-0 left-0 my-auto h-5 w-[283px] animate-pulse bg-primary-light-4 md:h-8 md:w-[475px]"
							/>
						</div>
					</div>
				</header>
				<div class="flex w-full flex-col gap-6 md:gap-9">
					<div class="flex gap-5 overflow-hidden">
						<div
							v-for="i in 6"
							:key="i"
							class="shrink-0 basis-[94%] md:basis-[48%] lg:basis-[32%] xl:basis-[24%]"
						>
							<div class="aspect-9/14 animate-pulse bg-primary-light-4" />
						</div>
					</div>
					<div
						class="flex h-auto w-full flex-col-reverse items-start justify-between gap-6 md:flex-row lg:items-center"
					>
						<div
							class="h-11 w-[220px] animate-pulse rounded-sm bg-primary-light-4 md:h-[52px]"
						/>
						<div class="flex w-full items-center justify-end gap-3">
							<div
								class="flex w-full flex-wrap justify-end gap-2 md:max-w-[420px] md:gap-3"
							>
								<div
									v-for="j in 6"
									:key="j"
									class="h-[2px] max-w-[60px] flex-1 bg-white/20"
								/>
							</div>
							<div class="flex max-w-[66px] gap-1 text-white/20 md:gap-2">
								<IconMaterialSymbolsLightChevronLeft
									width="32px"
									height="32px"
								/>
								<IconMaterialSymbolsLightChevronRight
									width="32px"
									height="32px"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
